import * as moment from "moment";

export class Certificates {
  id: string;
  bastidor: string;
  matricula: string;
  tipoCertificado: string;
  fechaCreacion: string;
  analista: string;
  estado: string;
  comentarios: string;

  static certificateFromJson(obj: Object) {
    let tcertificado = "";
    if (obj["peOtrasReformas"]) {
      tcertificado =
        obj["tipoReforma"] + ", " + obj["peOtrasReformas"].replace(/__/g, ", ");
      tcertificado =
        obj["tipoCertificado"] + " " + orderCodeReforms(tcertificado);
    } else if (obj["tipoReforma"]) {
      tcertificado = obj["tipoCertificado"] + " " + obj["tipoReforma"];
    } else {
      tcertificado = obj["tipoCertificado"];
    }

    return new Certificates(
      obj["solicitud"],
      obj["bastidor"],
      obj["matricula"],
      tcertificado,
      moment(obj["fechaCreacion"]).format("DD/MM/yyyy"),
      obj["usuario"],
      obj["estado"],
      obj["comentarios"]
    );
  }

  constructor(
    id: string,
    peBastidor: string,
    peMatricula: string,
    tcertificado: string,
    peCreacion: string,
    usuario: string,
    estado: string,
    comentarios: string
  ) {
    this.id = id;
    this.bastidor = peBastidor;
    this.matricula = peMatricula;
    this.tipoCertificado = tcertificado;
    this.fechaCreacion = peCreacion;
    this.analista = usuario;
    this.estado = estado;
    this.comentarios = comentarios;
  }
}
function orderCodeReforms(reforms: string): string {
  let reformsSelected: string[] = reforms.split(",");
  let peTcId: string = "";
  if (reformsSelected.length > 0) {
    reformsSelected.sort((a, b) => {
      return parseToFloat(a) - parseToFloat(b);
    });
    reformsSelected.forEach((e, index) => {
      if (index == 0) {
        peTcId = e;
      } else {
        peTcId += ", " + e;
      }
    });
  }
  return peTcId;
}

function parseToFloat(reform: string): number {
  let reformSplited = reform.trim().split(".");
  let floatCodigoReforma: number = 0.0;
  if (reformSplited.length > 1 && reformSplited[1].trim().length == 1) {
    reformSplited[0] = reformSplited[0] + ".0" + reformSplited[1].trim();
  } else {
    reformSplited[0] = reform;
  }

  floatCodigoReforma = parseFloat(reformSplited[0]);
  return floatCodigoReforma;
}
